import type { ImgHTMLAttributes } from 'react';

/** Instagram/Facebook CDNs block hotlinking without referrer policy. */
export function isExternalCdnUrl(url: string): boolean {
  try {
    const host = new URL(url).hostname;
    return (
      host.includes('cdninstagram.com') ||
      host.includes('fbcdn.net') ||
      host.includes('instagram.com')
    );
  } catch {
    return false;
  }
}

export function externalImageProps(src: string): Pick<
  ImgHTMLAttributes<HTMLImageElement>,
  'referrerPolicy' | 'crossOrigin'
> {
  if (!src.startsWith('http') || !isExternalCdnUrl(src)) return {};
  return { referrerPolicy: 'no-referrer', crossOrigin: 'anonymous' };
}
